import { localizedExerciseName, localizedField } from "./localizedCatalogFields";
import {
  blockTypeHeadline,
  isCompetencyBlockSlot,
} from "./planningSubgroups";
import { isKotExercise, isPersonalizedExercise } from "./teExecutionType";

/**
 * Session block that ran without a catalog exercise (type-only warmup,
 * off-table, …). Coaches can still pick the exercise performed afterwards.
 */
export function needsCatalogExercise(ex) {
  if (!ex?.te_id || ex.ex_id) return false;
  return !isKotExercise(ex) && !isPersonalizedExercise(ex);
}

function isGenericCompetencySubtypeName(name) {
  const n = String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
  if (!n) return false;
  return (
    n === "competency block" ||
    n === "competency blocks" ||
    n === "bloc de competence" ||
    n === "blocs de competence" ||
    n === "bloque de competencia" ||
    n === "bloques de competencia" ||
    n === "kompetenzblock" ||
    n === "kompetenzbloecke" ||
    n === "kompetenzblöcke" ||
    n === "blocks of competency"
  );
}

/**
 * Label for a block without a catalog name.
 * Warm-up / off-table: "Warm-up" or "Off-table - Agility".
 * Competency blocks: the CB kind only ("Forehand", "Backhand"), never
 * "Blocks of competency - Competency Block".
 */
export function blockTypeLabel(ex, lang = "en") {
  if (!ex) return "";
  if (isCompetencyBlockSlot(ex)) {
    return blockTypeHeadline(ex, lang);
  }
  const type = ex.type_ex || ex.tbl_type_ex || ex.capture_type_ex || null;
  const subType = ex.sub_type_ex || ex.tbl_sub_type_ex || null;
  const typeName = localizedField(type, "type_name", lang);
  const subName = localizedField(subType, "sub_type_name", lang);
  if (subName && isGenericCompetencySubtypeName(subName)) {
    return typeName || "";
  }
  return [typeName, subName].filter(Boolean).join(" - ");
}

/**
 * Title shown on training-exercise results.
 * Catalog drill when set; otherwise the exercise type or the competency
 * block being worked (never a bare "Competency Block" label).
 */
export function resultsExerciseDisplayName(ex, lang = "en") {
  if (!ex) return "";
  if (ex.ex_id) {
    const catalog = localizedExerciseName(ex, lang);
    if (catalog) return catalog;
  }
  // Backend may put the type name into ex_name for type-only slots —
  // prefer the typed / CB label so CB slots show Forehand, not
  // "Blocks of competency".
  return blockTypeLabel(ex, lang) || "";
}
